/** @jsxRuntime automatic */
/** @jsxImportSource react */
/**
 * Outfits and mascot › Gallery: the desktop mascot's outfits, on a page of their own since the overhaul's step 4 (they
 * were one card inside Governance). The page is the gallery container itself (components/DesktopMascotCard.tsx): the
 * gallery and its preview, Add an outfit, Add several outfits, Categories, Always see every outfit, Day outfits and the
 * history, with one state for all of them.
 */
import { DesktopMascotCard } from '../components/DesktopMascotCard';

export function Outfits() {
  return <DesktopMascotCard />;
}
